import { z } from "zod";
import { middleware } from "@/api/middleware";

/** A platform admin's read-only look at one organization (see the middleware's /platform/support-session). */
const supportSession = z.object({
  id: z.string(),
  tenant_id: z.string(),
  tenant_slug: z.string(),
  tenant_name: z.string(),
  reason: z.string(),
  expires_at: z.string(),
});

export type SupportSession = {
  id: string;
  tenantId: string;
  tenantSlug: string;
  tenantName: string;
  reason: string;
  expiresAt: string;
};

function toSession(raw: unknown): SupportSession {
  const row = supportSession.parse(raw);
  return {
    id: row.id,
    tenantId: row.tenant_id,
    tenantSlug: row.tenant_slug,
    tenantName: row.tenant_name,
    reason: row.reason,
    expiresAt: row.expires_at,
  };
}

/** The caller's live session, or `null`. */
export async function getSupportSession(): Promise<SupportSession | null> {
  const raw = await middleware.get<unknown>("platform/support-session");
  return raw === null || raw === undefined ? null : toSession(raw);
}

export async function startSupportSession(tenantId: string, reason: string): Promise<SupportSession> {
  return toSession(await middleware.post<unknown>(`platform/tenants/${tenantId}/support-session`, { reason }));
}

export async function endSupportSession(): Promise<void> {
  await middleware.delete<unknown>("platform/support-session");
}
